import styled from "styled-components";
import { Headline } from "../../../../components";
import { media } from "../../../../utils";

export default styled(Headline)`
  display: none;
  ${media.md()} {
    display: block;
  }
`;
